// extracted by mini-css-extract-plugin
export default {"frameHeader":"FrameSectionHeader_frameHeader__uLpdE","offsetPadding":"FrameSectionHeader_offsetPadding__IbBAG","icon":"FrameSectionHeader_icon__Q7iNW"};